/**
 * The languages the marketing site publishes in, as Ant Design options.
 *
 * One list: the same pair had been written out in the three screens that show
 * a BG/EN switch, which is three chances to disagree about a label.
 */
export const LANGUAGES = [
  { label: "Български", value: "bg" },
  { label: "English", value: "en" },
];
